import { api } from '../feathers-client'

// Provides access to Feathers Client(s)
export const useFeathers = () => {
  return api
}

/**
 * Returns a service to work with Feathers-Pinia. It currently does not handle custom methods.
 * @param servicePath the path of the service
 */
export const useFeathersService = (servicePath, clientAlias = 'api') => {
  const clients = useFeathers()
  const client = clients[clientAlias]
  return client.service(servicePath)
}
